import Vue from 'vue'

// import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // Internationalization
import './icons' // icon
import './errorLog' // error log
import './permission' // permission control

import * as filters from './filters' // global filters
// 通过指令permission  + permissionUrl 做权限控制按钮隐藏
import VueSelectl from 'vue-selectl'
import 'vue-selectl/dist/styles.css'
import Print from 'vue-print-nb'

Vue.use(Print)

Vue.use(VueSelectl)
Vue.directive('permission', {
  bind(el, binding, vnode, oldVnode) {
    if (!findPermission(el.getAttribute('permissionUrl'))) {
      el.setAttribute('style', 'display:none')
    }
  }
})
function findPermission(url) {
  let find = false
  const permissionArray = store.getters.actionUrl
  permissionArray.forEach(element => {
    if (element.url === url) {
      find = true
    }
  })
  return find
}
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
